export default {
  async vircos_init(_vm) {

  },
  vircos_getProjectCode(projectId, _vm) {
    const project = _vm.$store.getters['projects/get'](projectId);
    const supplier = _vm.$store.getters['works/get'](project.developers[0]);
    //Recupero il cliente
    //Calcolo il codice di progetto - dipende anche dai progetti precedenti
  },
  vircos_getCompanies() {
    return [
      {
        id: 'rvt',
        label: 'REV\'IT!'
      },
      {
        id: 'vrs',
        label: 'Vircos'
      },
      {
        id: 'mcn',
        label: 'Macna'
      },
      {
        id: 'brg',
        label: 'Bering'
      },
      {
        id: 'mth',
        label: 'Mithos'
      },
      {
        id: 'wse',
        label: 'Weise'
      },
      {
        id: 'svt',
        label: '70 degrees'
      },
      {
        id: 'asd',
        label: 'ASD'
      },
      {
        id: 'gfm',
        label: 'GFM'
      },
      {
        id: 'rch',
        label: 'Richa'
      },
      {
        id: 'elv',
        label: 'Eleveit'
      },
      {
        id: 'fiv',
        label: 'Five'
      },
      {
        id: 'mtp',
        label: 'Motoport'
      }
    ]
  },
  // Gli id sono in base al popolamento della tabella contacts_contact_lead_channel
  vircos_getChannels() {
    return [
      {
        id: 27,
        label: 'CIV'
      },
      {
        id: 28,
        label: 'CITA'
      },
      {
        id: 29,
        label: 'BSB'
      },
      {
        id: 30,
        label: 'MotoGP'
      },
      {
        id: 31,
        label: 'SBK'
      },
      {
        id: 32,
        label: 'CEV'
      },
      {
        id: 33,
        label: 'ESBK'
      },
      {
        id: 34,
        label: 'Showroom'
      },
      {
        id: 35,
        label: 'Online'
      }
    ]
  },
  vircos_getDeliveryTypes(_vm) {
    return [
      {
        id: 'pickUp',
        label: _vm.$anm22.strLang(_vm.lang, 'Pick up', 'Ritiro in sede')
      },
      {
        id: 'shipping',
        label: _vm.$anm22.strLang(_vm.lang, 'Shipment', 'Spedire')
      },
      {
        id: 'call',
        label: _vm.$anm22.strLang(_vm.lang, 'Call', 'Chiamare')
      },
      {
        id: 'civ',
        label: 'CIV'
      },
      {
        id: 'ita',
        label: 'C.ITA'
      },
      {
        id: 'gp',
        label: 'GP'
      },
      {
        id: 'sbk',
        label: 'SBK'
      },
      {
        id: 'bsb',
        label: 'BSB'
      },
      {
        id: 'fim',
        label: 'FIM'
      },
      {
        id: 'esbk',
        label: 'ESBK'
      }
    ]
  },
  vircos_getDeliveryCarriers(_vm) {
    return [
      {
        id: 'gls',
        label: 'GLS'
      },
      {
        id: 'brt',
        label: 'BRT'
      },
      {
        id: 'ups',
        label: 'UPS'
      },
      {
        id: 'dhl',
        label: 'DHL'
      },
      {
        id: 'fedex',
        label: 'FedEx'
      },
      {
        id: 'mbe',
        label: 'MBE'
      }
    ]
  }
}